import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Minus, Plus } from "lucide-react";
import moment from "moment";


const BillsProductForm = ({ show, onClose, heading, initialData = {}, onSubmit, categories, customers, products }) => {
    // State to manage form inputs
    const [formData, setFormData] = useState({
        customer_id: '',
        bill_date: '',
        due_date: '',
        bill_number: '',
        order_number: '',
        raw_products: [{ id: '', quantity: '', price: '', discount_type: '', discount: '', total_amount: '', description: '' }]
    });

    // Load initial data into form if editing an existing tax
    useEffect(() => {
        if (initialData) {
            setFormData({
                customer_id: initialData.customer_id || '',
                bill_date: initialData.bill_date ? moment(initialData.bill_date).format('YYYY-MM-DD') : '',
                due_date: initialData.due_date ? moment(initialData.due_date).format('YYYY-MM-DD') : '',
                bill_number: initialData.bill_number || '',
                order_number: initialData.order_number || '',
                raw_products: initialData.BillProducts?.length > 0 
                    ? initialData.BillProducts.map((product) => ({
                        id: product.product_id || '',
                        quantity: product.quantity || '',
                        price: product.price || '',
                        discount_type: product.discount_type || '',
                        discount: product.discount || '',
                        total_amount: product.total_amount || '',
                        description: product.description || ''
                    }))
                    : [{ id: '', quantity: '', price: '', discount_type: '', discount: '', total_amount: '', description: '' }]
            });
        }
    }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormData(prevFormData => {
            let updatedFormData = { ...prevFormData, [name]: value };
    
            // Reset raw_products if vendor_id changes
            if (name === 'vendor_id') {
                updatedFormData.raw_products = [{ id: '', quantity: '', price: '', discount_type: '', discount: '', total_amount: '', description: '' }];
            }
    
            return updatedFormData;
        });
    };

    const handleDynamicChange = (e, index, field) => {
        const { value } = e.target;

        const updatedProducts = formData.raw_products.map((product, idx) => {
            if (idx === index) {
                let updatedProduct = { ...product, [field]: value };

                // Ensure ID is valid before fetching purchase cost
                if (field == "id") {
                    const selectedProduct = products.find(p => p.id == value);
                    console.log('selected Prod', selectedProduct);
                    if (selectedProduct) {
                    
                        const purchaseCost = selectedProduct ? selectedProduct.purchase_cost : 0;
                        console.log('selected Prod costtt', purchaseCost);
                        updatedProduct.price = purchaseCost;
                        updatedProduct.quantity = 1; // Reset quantity to 1 when selecting a new product
                        updatedProduct.total_amount = purchaseCost;
                    }
                }
                
                // Auto-calculate total price if quantity is updated
                if (field == "quantity") {
                    const selectedProduct = products.find(p => p.id == updatedProduct.id);
                    console.log('selected Prod', selectedProduct);
                    if (selectedProduct) {
                        // const vendorData = selectedProduct.RawProductVendors.find(vendor => vendor.vendor_id == formData.vendor_id);
                        const purchaseCost = selectedProduct ? selectedProduct.purchase_cost : 0;
                        console.log('selected Prod costtt', purchaseCost);
                        updatedProduct.price = purchaseCost * value;
                        updatedProduct.total_amount = purchaseCost * value;
                    }
                }
                

                // Auto-calculate total amount if discount or discount_type is updated
                if (["discount", "discount_type", "quantity"].includes(field)) {
                    let totalAmount = parseFloat(updatedProduct.price) || 0;
                    const discount = parseFloat(updatedProduct.discount) || 0;
                    const discountType = updatedProduct.discount_type;

                    if (discountType === "percentage") {
                        totalAmount -= (totalAmount * discount) / 100;
                    } else if (discountType === "flat") {
                        totalAmount -= discount;
                    }

                    updatedProduct.total_amount = totalAmount > 0 ? totalAmount : 0; // Ensure total is not negative
                }

                return updatedProduct;
            }
            return product;
        });

        setFormData({ ...formData, raw_products: updatedProducts });
    };



    // Add a new row to raw products
    const handleAddRow = () => {
        setFormData({
            ...formData,
            raw_products: [...formData.raw_products, { id: '', quantity: '', price: '', discount_type: '', discount: '', total_amount: '', description: '' }]
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Customer</label>
                            <select
                                name="customer_id"
                                className="form-control"
                                value={formData.customer_id}
                                onChange={handleChange}
                            >
                                <option value={''}>Select Customer</option>
                                {customers.map((data) => <option key={data.id} value={data.id}>{data.name}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bill Date</label>
                            <input
                                type="date"
                                name="bill_date"
                                className="form-control"
                                value={formData.bill_date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Receiving Date</label>
                            <input
                                type="date"
                                name="due_date"
                                className="form-control"
                                value={formData.due_date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bill Number</label>
                            <input
                                type="text"
                                name="bill_number"
                                className="form-control"
                                value={formData.bill_number}
                                onChange={handleChange}
                                placeholder="Enter Bill Number"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Order Number</label>
                            <input
                                type="text"
                                name="order_number"
                                className="form-control"
                                value={formData.order_number}
                                onChange={handleChange}
                                placeholder="Enter Order Number"
                                required
                            />
                        </div>
                    </div>

                    {/* Render all supplier-cost pairs */}
                    <div className="col-md-12">
                        <label>Products</label>
                        {formData.raw_products.map((rawProduct, index) => {
                            console.log('selectt dpdd', rawProduct.id);
                            return (
                                <div key={index} style={{
                                    borderTop: "1px solid #eee",
                                    borderBottom: "1px solid #000"
                                }}>
                                    <div className="row" style={{
                                        margin: "15px 0px",
                                    }}>
                                        {/* Raw Product Select */}
                                        <div className="col-md-3">
                                            <div className="form-group mb-4">
                                                <label>Product</label>
                                                {/* <select
                                                    name="id"
                                                    className="form-control"
                                                    value={rawProduct.id}
                                                    onChange={(e) => handleDynamicChange(e, index, 'id')}
                                                >
                                                    <option value="">Select Raw Product</option>
                                                    {rawProducts.map((product) => (
                                                        <option key={product.id} value={product.id}>
                                                            {product.name}
                                                        </option>
                                                    ))}
                                                </select> */}
                                                <select
                                                    name="id"
                                                    className="form-control"
                                                    value={rawProduct.id}
                                                    onChange={(e) => handleDynamicChange(e, index, 'id')}
                                                >
                                                    <option value="">Select Raw Product</option>
                                                    {products.map((product) => (
                                                            <option key={product.id} value={product.id}>
                                                                {product.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Quantity */}
                                        <div className="col-md-2">
                                            <div className="form-group mb-4">
                                                <label>Quantity</label>
                                                <input
                                                    type="number"
                                                    name="quantity"
                                                    className="form-control"
                                                    value={rawProduct.quantity}
                                                    onChange={(e) => handleDynamicChange(e, index, 'quantity')}
                                                    placeholder="Enter Quantity"
                                                />
                                            </div>
                                        </div>

                                        {/* Price */}
                                        <div className="col-md-2">
                                            <div className="form-group mb-4">
                                                <label>Price</label>
                                                <input
                                                    type="number"
                                                    name="price"
                                                    className="form-control"
                                                    value={rawProduct.price}
                                                    onChange={(e) => handleDynamicChange(e, index, 'price')}
                                                    placeholder="Enter Price"
                                                />
                                            </div>
                                        </div>

                                        {/* Discount Type */}
                                        <div className="col-md-2">
                                            <div className="form-group mb-4">
                                                <label>Discount Type</label>
                                                <select
                                                    name="discount_type"
                                                    className="form-control"
                                                    value={rawProduct.discount_type}
                                                    onChange={(e) => handleDynamicChange(e, index, 'discount_type')}
                                                >
                                                    <option value="">Select Discount Type</option>
                                                    <option value="percentage">Percentage</option>
                                                    <option value="flat">Flat</option>
                                                </select>
                                            </div>
                                        </div>

                                        {/* Discount */}
                                        <div className="col-md-2">
                                            <div className="form-group mb-4">
                                                <label>Discount</label>
                                                <input
                                                    type="number"
                                                    name="discount"
                                                    className="form-control"
                                                    value={rawProduct.discount}
                                                    onChange={(e) => handleDynamicChange(e, index, 'discount')}
                                                    placeholder="Enter Discount"
                                                />
                                            </div>
                                        </div>

                                        {/* Total Amount */}
                                        <div className="col-md-2">
                                            <div className="form-group mb-4">
                                                <label>Total Amount</label>
                                                <input
                                                    type="number"
                                                    name="total_amount"
                                                    className="form-control"
                                                    value={rawProduct.total_amount}
                                                    onChange={(e) => handleDynamicChange(e, index, 'total_amount')}
                                                    placeholder="Enter Total Amount"
                                                />
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="col-md-3">
                                            <div className="form-group mb-4">
                                                <label>Description</label>
                                                <input
                                                    type="text"
                                                    name="description"
                                                    className="form-control"
                                                    value={rawProduct.description}
                                                    onChange={(e) => handleDynamicChange(e, index, 'description')}
                                                    placeholder="Enter Description"
                                                />
                                            </div>
                                        </div>

                                        {/* Add/Remove Row Buttons */}
                                        <div className="col-md-1">
                                            {index === 0 ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary mt-4"
                                                    onClick={handleAddRow}
                                                >
                                                    <Plus />
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger mt-4"
                                                    onClick={() => {
                                                        const updatedProducts = formData.raw_products.filter((_, idx) => idx !== index);
                                                        setFormData({ ...formData, raw_products: updatedProducts });
                                                    }}
                                                >
                                                    <Minus />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn btn-light me-2"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default BillsProductForm;
